import { createSelector } from "@ngrx/store";
import { selectFeature } from "./_base";

export const dcfState = createSelector(
    selectFeature,
    (state) => {
        if (state.valuationProcess.kind === 'unknown') return null;
        if (state.valuationProcess.kind === 'market') return null;
        return {
            gross_market_rent: state.valuationProcess.data.grossMarketrent,
            opex: state.valuationProcess.data.opex,
            void_period_allowance: state.valuationProcess.data.voidPeriodAllowance,
            holding_period: state.valuationProcess.data.holdingPeriod,
            terminal_capital_rate: state.valuationProcess.data.terminalCapitalRate,
            annual_growth_rate: state.valuationProcess.data.annualGrowthRate,
            annual_opex_rate: state.valuationProcess.data.annualOpexRate,
            disposal_cost_on_exit: state.valuationProcess.data.disposalCostOnExit,
            discount_rate: state.valuationProcess.data.discountRate,
            value: state.valuationProcess.data.dcfValue,
            file_name: state.valuationProcess.data.fileName,
            file_path: state.valuationProcess.data.filePath
        }
    }
)